import TagThemes from 'components/tags/basic-tag/themes'

const MaterialsType = {
  WEBINAR: 'Вебинар',
  VIDEO: 'Видео',
  WEBINAR_PAST: 'Запись вебинара',
  ARTICLE: 'Статья',
  CLINIC: 'Клин. рекомендация',
  CLINIC_CASE: 'Клин. случай',
  PODCAST: 'Подкаст',
}

const MaterialsColor = {
  [MaterialsType.WEBINAR]: TagThemes.ORANGE,
  [MaterialsType.VIDEO]: TagThemes.BLUE,
  [MaterialsType.WEBINAR_PAST]: TagThemes.PINK,
  [MaterialsType.ARTICLE]: TagThemes.GREEN,
  [MaterialsType.CLINIC]: TagThemes.BLUE,
  [MaterialsType.CLINIC_CASE]: TagThemes.PURPLE,
  [MaterialsType.PODCAST]: TagThemes.PINK,
}

export { MaterialsType, MaterialsColor }
